module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "iscroll",
      rawName: "v-iscroll"
    }],
    staticClass: "office-detail-list"
  }, [_c('ul', {
    staticClass: "office-list-warp"
  }, _vm._l((_vm.offDetailList), function(item, index) {
    return _c('li', {
      staticClass: "list",
      class: {
        active: item.finish
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('div', {
      staticClass: "time-name"
    }, [_c('span', {
      staticClass: "inner-time"
    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('span', {
      staticClass: "inner-thing"
    }, [_vm._v("公证事项：" + _vm._s(item.matter))]), _vm._v(" "), _c('span', {
      staticClass: "inner-name"
    }, [_vm._v("当事人：" + _vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "git-in"
    }, [_c('span', {
      staticClass: "git-in-text"
    }, [_vm._v("\n            " + _vm._s(item.code) + "\n          ")]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-finish"
    })])])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "git-in-icon"
  }, [_c('i', {
    staticClass: "iconfont icon-photograph"
  }), _vm._v("\n            实时监控\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-424297ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/office-detail-list.vue
// module id = 180
// module chunks = 1